import { interval } from 'rxjs';

import store from '../../../store';

const POLLING_INTERVAL = 2 * 60 * 1000;

/**
 * 轮询门店营业状态
 */
const init = () => {
    interval(POLLING_INTERVAL).subscribe(() => {
        store.dispatch({ type: 'shellHeader/getBusinessStatus' });
    });
};

export default { init };
